/**
 * @fileoverview gRPC-Web generated client stub for no.jotta.openapi.customer.v2
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v4.22.5
// source: no/jotta/openapi/customer/customer.v2.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var no_jotta_openapi_ping_pb = require('../../../../no/jotta/openapi/ping_pb.js')

var no_jotta_openapi_ref_pb = require('../../../../no/jotta/openapi/ref_pb.js')

var no_jotta_openapi_credentials_pb = require('../../../../no/jotta/openapi/credentials_pb.js')

var no_jotta_openapi_language_pb = require('../../../../no/jotta/openapi/language_pb.js')

var no_jotta_openapi_country_pb = require('../../../../no/jotta/openapi/country_pb.js')

var no_jotta_openapi_auth_v2_auth_v2_pb = require('../../../../no/jotta/openapi/auth/v2/auth.v2_pb.js')

var no_jotta_openapi_file_file_v2_pb = require('../../../../no/jotta/openapi/file/file.v2_pb.js')

var no_jotta_openapi_wopi_pb = require('../../../../no/jotta/openapi/wopi_pb.js')

var no_jotta_openapi_avatar_pb = require('../../../../no/jotta/openapi/avatar_pb.js')

var google_api_annotations_pb = require('../../../../google/api/annotations_pb.js')

var no_jotta_protobuf_wrappers_pb = require('../../../../no/jotta/protobuf/wrappers_pb.js')

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js')
const proto = {};
proto.no = {};
proto.no.jotta = {};
proto.no.jotta.openapi = {};
proto.no.jotta.openapi.customer = {};
proto.no.jotta.openapi.customer.v2 = require('./customer.v2_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.no.jotta.openapi.customer.v2.CustomerServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.no.jotta.openapi.customer.v2.CustomerServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.customer.v2.GetCustomerRequest,
 *   !proto.no.jotta.openapi.customer.v2.GetCustomerResponse>}
 */
const methodDescriptor_CustomerService_GetCustomer = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.customer.v2.CustomerService/GetCustomer',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.customer.v2.GetCustomerRequest,
  proto.no.jotta.openapi.customer.v2.GetCustomerResponse,
  /**
   * @param {!proto.no.jotta.openapi.customer.v2.GetCustomerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.customer.v2.GetCustomerResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.customer.v2.GetCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.customer.v2.GetCustomerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.customer.v2.GetCustomerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.customer.v2.CustomerServiceClient.prototype.getCustomer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.customer.v2.CustomerService/GetCustomer',
      request,
      metadata || {},
      methodDescriptor_CustomerService_GetCustomer,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.customer.v2.GetCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.customer.v2.GetCustomerResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.customer.v2.CustomerServicePromiseClient.prototype.getCustomer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.customer.v2.CustomerService/GetCustomer',
      request,
      metadata || {},
      methodDescriptor_CustomerService_GetCustomer);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.customer.v2.PatchCustomerRequest,
 *   !proto.no.jotta.openapi.customer.v2.PatchCustomerResponse>}
 */
const methodDescriptor_CustomerService_PatchCustomer = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.customer.v2.CustomerService/PatchCustomer',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.customer.v2.PatchCustomerRequest,
  proto.no.jotta.openapi.customer.v2.PatchCustomerResponse,
  /**
   * @param {!proto.no.jotta.openapi.customer.v2.PatchCustomerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.customer.v2.PatchCustomerResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.customer.v2.PatchCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.customer.v2.PatchCustomerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.customer.v2.PatchCustomerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.customer.v2.CustomerServiceClient.prototype.patchCustomer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.customer.v2.CustomerService/PatchCustomer',
      request,
      metadata || {},
      methodDescriptor_CustomerService_PatchCustomer,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.customer.v2.PatchCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.customer.v2.PatchCustomerResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.customer.v2.CustomerServicePromiseClient.prototype.patchCustomer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.customer.v2.CustomerService/PatchCustomer',
      request,
      metadata || {},
      methodDescriptor_CustomerService_PatchCustomer);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.customer.v2.GetFamilyRequest,
 *   !proto.no.jotta.openapi.customer.v2.GetFamilyResponse>}
 */
const methodDescriptor_CustomerService_GetFamily = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.customer.v2.CustomerService/GetFamily',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.customer.v2.GetFamilyRequest,
  proto.no.jotta.openapi.customer.v2.GetFamilyResponse,
  /**
   * @param {!proto.no.jotta.openapi.customer.v2.GetFamilyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.customer.v2.GetFamilyResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.customer.v2.GetFamilyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.customer.v2.GetFamilyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.customer.v2.GetFamilyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.customer.v2.CustomerServiceClient.prototype.getFamily =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.customer.v2.CustomerService/GetFamily',
      request,
      metadata || {},
      methodDescriptor_CustomerService_GetFamily,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.customer.v2.GetFamilyRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.customer.v2.GetFamilyResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.customer.v2.CustomerServicePromiseClient.prototype.getFamily =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.customer.v2.CustomerService/GetFamily',
      request,
      metadata || {},
      methodDescriptor_CustomerService_GetFamily);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.customer.v2.SendFamilyInviteRequest,
 *   !proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse>}
 */
const methodDescriptor_CustomerService_SendFamilyInvite = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.customer.v2.CustomerService/SendFamilyInvite',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.customer.v2.SendFamilyInviteRequest,
  proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse,
  /**
   * @param {!proto.no.jotta.openapi.customer.v2.SendFamilyInviteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.customer.v2.SendFamilyInviteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.customer.v2.CustomerServiceClient.prototype.sendFamilyInvite =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.customer.v2.CustomerService/SendFamilyInvite',
      request,
      metadata || {},
      methodDescriptor_CustomerService_SendFamilyInvite,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.customer.v2.SendFamilyInviteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.customer.v2.SendFamilyInviteResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.customer.v2.CustomerServicePromiseClient.prototype.sendFamilyInvite =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.customer.v2.CustomerService/SendFamilyInvite',
      request,
      metadata || {},
      methodDescriptor_CustomerService_SendFamilyInvite);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.customer.v2.TerminateAccountRequest,
 *   !proto.no.jotta.openapi.customer.v2.TerminateAccountResponse>}
 */
const methodDescriptor_CustomerService_TerminateAccount = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.customer.v2.CustomerService/TerminateAccount',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.customer.v2.TerminateAccountRequest,
  proto.no.jotta.openapi.customer.v2.TerminateAccountResponse,
  /**
   * @param {!proto.no.jotta.openapi.customer.v2.TerminateAccountRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.customer.v2.TerminateAccountResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.customer.v2.TerminateAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.customer.v2.TerminateAccountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.customer.v2.TerminateAccountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.customer.v2.CustomerServiceClient.prototype.terminateAccount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.customer.v2.CustomerService/TerminateAccount',
      request,
      metadata || {},
      methodDescriptor_CustomerService_TerminateAccount,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.customer.v2.TerminateAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.customer.v2.TerminateAccountResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.customer.v2.CustomerServicePromiseClient.prototype.terminateAccount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.customer.v2.CustomerService/TerminateAccount',
      request,
      metadata || {},
      methodDescriptor_CustomerService_TerminateAccount);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.customer.v2.DowngradeAccountRequest,
 *   !proto.no.jotta.openapi.customer.v2.DowngradeAccountResponse>}
 */
const methodDescriptor_CustomerService_DowngradeAccount = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.customer.v2.CustomerService/DowngradeAccount',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.customer.v2.DowngradeAccountRequest,
  proto.no.jotta.openapi.customer.v2.DowngradeAccountResponse,
  /**
   * @param {!proto.no.jotta.openapi.customer.v2.DowngradeAccountRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.customer.v2.DowngradeAccountResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.customer.v2.DowngradeAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.customer.v2.DowngradeAccountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.customer.v2.DowngradeAccountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.customer.v2.CustomerServiceClient.prototype.downgradeAccount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.customer.v2.CustomerService/DowngradeAccount',
      request,
      metadata || {},
      methodDescriptor_CustomerService_DowngradeAccount,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.customer.v2.DowngradeAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.customer.v2.DowngradeAccountResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.customer.v2.CustomerServicePromiseClient.prototype.downgradeAccount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.customer.v2.CustomerService/DowngradeAccount',
      request,
      metadata || {},
      methodDescriptor_CustomerService_DowngradeAccount);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.auth.v2.GenerateLoginTokenRequest,
 *   !proto.no.jotta.openapi.auth.v2.GenerateLoginTokenResponse>}
 */
const methodDescriptor_CustomerService_GenerateLoginToken = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.customer.v2.CustomerService/GenerateLoginToken',
  grpc.web.MethodType.UNARY,
  no_jotta_openapi_auth_v2_auth_v2_pb.GenerateLoginTokenRequest,
  no_jotta_openapi_auth_v2_auth_v2_pb.GenerateLoginTokenResponse,
  /**
   * @param {!proto.no.jotta.openapi.auth.v2.GenerateLoginTokenRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  no_jotta_openapi_auth_v2_auth_v2_pb.GenerateLoginTokenResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.auth.v2.GenerateLoginTokenRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.auth.v2.GenerateLoginTokenResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.auth.v2.GenerateLoginTokenResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.customer.v2.CustomerServiceClient.prototype.generateLoginToken =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.customer.v2.CustomerService/GenerateLoginToken',
      request,
      metadata || {},
      methodDescriptor_CustomerService_GenerateLoginToken,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.auth.v2.GenerateLoginTokenRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.auth.v2.GenerateLoginTokenResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.customer.v2.CustomerServicePromiseClient.prototype.generateLoginToken =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.customer.v2.CustomerService/GenerateLoginToken',
      request,
      metadata || {},
      methodDescriptor_CustomerService_GenerateLoginToken);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.customer.v2.ApproveLoginRequest,
 *   !proto.no.jotta.openapi.customer.v2.ApproveLoginResponse>}
 */
const methodDescriptor_CustomerService_ApproveLogin = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.customer.v2.CustomerService/ApproveLogin',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.customer.v2.ApproveLoginRequest,
  proto.no.jotta.openapi.customer.v2.ApproveLoginResponse,
  /**
   * @param {!proto.no.jotta.openapi.customer.v2.ApproveLoginRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.customer.v2.ApproveLoginResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.customer.v2.ApproveLoginRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.customer.v2.ApproveLoginResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.customer.v2.ApproveLoginResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.customer.v2.CustomerServiceClient.prototype.approveLogin =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.customer.v2.CustomerService/ApproveLogin',
      request,
      metadata || {},
      methodDescriptor_CustomerService_ApproveLogin,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.customer.v2.ApproveLoginRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.customer.v2.ApproveLoginResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.customer.v2.CustomerServicePromiseClient.prototype.approveLogin =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.customer.v2.CustomerService/ApproveLogin',
      request,
      metadata || {},
      methodDescriptor_CustomerService_ApproveLogin);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.auth.v2.InitializeTFARequest,
 *   !proto.no.jotta.openapi.auth.v2.InitializeTFAResponse>}
 */
const methodDescriptor_CustomerService_InitializeTFA = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.customer.v2.CustomerService/InitializeTFA',
  grpc.web.MethodType.UNARY,
  no_jotta_openapi_auth_v2_auth_v2_pb.InitializeTFARequest,
  no_jotta_openapi_auth_v2_auth_v2_pb.InitializeTFAResponse,
  /**
   * @param {!proto.no.jotta.openapi.auth.v2.InitializeTFARequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  no_jotta_openapi_auth_v2_auth_v2_pb.InitializeTFAResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.auth.v2.InitializeTFARequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.auth.v2.InitializeTFAResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.auth.v2.InitializeTFAResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.customer.v2.CustomerServiceClient.prototype.initializeTFA =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.customer.v2.CustomerService/InitializeTFA',
      request,
      metadata || {},
      methodDescriptor_CustomerService_InitializeTFA,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.auth.v2.InitializeTFARequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.auth.v2.InitializeTFAResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.customer.v2.CustomerServicePromiseClient.prototype.initializeTFA =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.customer.v2.CustomerService/InitializeTFA',
      request,
      metadata || {},
      methodDescriptor_CustomerService_InitializeTFA);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.auth.v2.ConfirmTFARequest,
 *   !proto.no.jotta.openapi.auth.v2.ConfirmTFAResponse>}
 */
const methodDescriptor_CustomerService_ConfirmTFA = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.customer.v2.CustomerService/ConfirmTFA',
  grpc.web.MethodType.UNARY,
  no_jotta_openapi_auth_v2_auth_v2_pb.ConfirmTFARequest,
  no_jotta_openapi_auth_v2_auth_v2_pb.ConfirmTFAResponse,
  /**
   * @param {!proto.no.jotta.openapi.auth.v2.ConfirmTFARequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  no_jotta_openapi_auth_v2_auth_v2_pb.ConfirmTFAResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.auth.v2.ConfirmTFARequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.auth.v2.ConfirmTFAResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.auth.v2.ConfirmTFAResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.customer.v2.CustomerServiceClient.prototype.confirmTFA =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.customer.v2.CustomerService/ConfirmTFA',
      request,
      metadata || {},
      methodDescriptor_CustomerService_ConfirmTFA,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.auth.v2.ConfirmTFARequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.auth.v2.ConfirmTFAResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.customer.v2.CustomerServicePromiseClient.prototype.confirmTFA =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.customer.v2.CustomerService/ConfirmTFA',
      request,
      metadata || {},
      methodDescriptor_CustomerService_ConfirmTFA);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.auth.v2.DisableTFARequest,
 *   !proto.no.jotta.openapi.auth.v2.DisableTFAResponse>}
 */
const methodDescriptor_CustomerService_DisableTFA = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.customer.v2.CustomerService/DisableTFA',
  grpc.web.MethodType.UNARY,
  no_jotta_openapi_auth_v2_auth_v2_pb.DisableTFARequest,
  no_jotta_openapi_auth_v2_auth_v2_pb.DisableTFAResponse,
  /**
   * @param {!proto.no.jotta.openapi.auth.v2.DisableTFARequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  no_jotta_openapi_auth_v2_auth_v2_pb.DisableTFAResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.auth.v2.DisableTFARequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.auth.v2.DisableTFAResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.auth.v2.DisableTFAResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.customer.v2.CustomerServiceClient.prototype.disableTFA =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.customer.v2.CustomerService/DisableTFA',
      request,
      metadata || {},
      methodDescriptor_CustomerService_DisableTFA,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.auth.v2.DisableTFARequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.auth.v2.DisableTFAResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.customer.v2.CustomerServicePromiseClient.prototype.disableTFA =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.customer.v2.CustomerService/DisableTFA',
      request,
      metadata || {},
      methodDescriptor_CustomerService_DisableTFA);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteRequest,
 *   !proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteResponse>}
 */
const methodDescriptor_CustomerService_RevokeFamilyInvite = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.customer.v2.CustomerService/RevokeFamilyInvite',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteRequest,
  proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteResponse,
  /**
   * @param {!proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.customer.v2.CustomerServiceClient.prototype.revokeFamilyInvite =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.customer.v2.CustomerService/RevokeFamilyInvite',
      request,
      metadata || {},
      methodDescriptor_CustomerService_RevokeFamilyInvite,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.customer.v2.RevokeFamilyInviteResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.customer.v2.CustomerServicePromiseClient.prototype.revokeFamilyInvite =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.customer.v2.CustomerService/RevokeFamilyInvite',
      request,
      metadata || {},
      methodDescriptor_CustomerService_RevokeFamilyInvite);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteRequest,
 *   !proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteResponse>}
 */
const methodDescriptor_CustomerService_AcceptFamilyInvite = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.customer.v2.CustomerService/AcceptFamilyInvite',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteRequest,
  proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteResponse,
  /**
   * @param {!proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.customer.v2.CustomerServiceClient.prototype.acceptFamilyInvite =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.customer.v2.CustomerService/AcceptFamilyInvite',
      request,
      metadata || {},
      methodDescriptor_CustomerService_AcceptFamilyInvite,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.customer.v2.AcceptFamilyInviteResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.customer.v2.CustomerServicePromiseClient.prototype.acceptFamilyInvite =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.customer.v2.CustomerService/AcceptFamilyInvite',
      request,
      metadata || {},
      methodDescriptor_CustomerService_AcceptFamilyInvite);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.customer.v2.SetOnboardingTaskRequest,
 *   !proto.no.jotta.openapi.customer.v2.SetOnboardingTaskResponse>}
 */
const methodDescriptor_CustomerService_SetOnboardingTask = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.customer.v2.CustomerService/SetOnboardingTask',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.customer.v2.SetOnboardingTaskRequest,
  proto.no.jotta.openapi.customer.v2.SetOnboardingTaskResponse,
  /**
   * @param {!proto.no.jotta.openapi.customer.v2.SetOnboardingTaskRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.customer.v2.SetOnboardingTaskResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.customer.v2.SetOnboardingTaskRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.customer.v2.SetOnboardingTaskResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.customer.v2.SetOnboardingTaskResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.customer.v2.CustomerServiceClient.prototype.setOnboardingTask =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.customer.v2.CustomerService/SetOnboardingTask',
      request,
      metadata || {},
      methodDescriptor_CustomerService_SetOnboardingTask,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.customer.v2.SetOnboardingTaskRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.customer.v2.SetOnboardingTaskResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.customer.v2.CustomerServicePromiseClient.prototype.setOnboardingTask =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.customer.v2.CustomerService/SetOnboardingTask',
      request,
      metadata || {},
      methodDescriptor_CustomerService_SetOnboardingTask);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.customer.v2.CreateIdentityLinkRequest,
 *   !proto.no.jotta.openapi.customer.v2.CreateIdentityLinkResponse>}
 */
const methodDescriptor_CustomerService_CreateIdentityLink = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.customer.v2.CustomerService/CreateIdentityLink',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.customer.v2.CreateIdentityLinkRequest,
  proto.no.jotta.openapi.customer.v2.CreateIdentityLinkResponse,
  /**
   * @param {!proto.no.jotta.openapi.customer.v2.CreateIdentityLinkRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.customer.v2.CreateIdentityLinkResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.customer.v2.CreateIdentityLinkRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.customer.v2.CreateIdentityLinkResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.customer.v2.CreateIdentityLinkResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.customer.v2.CustomerServiceClient.prototype.createIdentityLink =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.customer.v2.CustomerService/CreateIdentityLink',
      request,
      metadata || {},
      methodDescriptor_CustomerService_CreateIdentityLink,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.customer.v2.CreateIdentityLinkRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.customer.v2.CreateIdentityLinkResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.customer.v2.CustomerServicePromiseClient.prototype.createIdentityLink =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.customer.v2.CustomerService/CreateIdentityLink',
      request,
      metadata || {},
      methodDescriptor_CustomerService_CreateIdentityLink);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.PingRequest,
 *   !proto.no.jotta.openapi.PingResponse>}
 */
const methodDescriptor_CustomerService_Ping = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.customer.v2.CustomerService/Ping',
  grpc.web.MethodType.UNARY,
  no_jotta_openapi_ping_pb.PingRequest,
  no_jotta_openapi_ping_pb.PingResponse,
  /**
   * @param {!proto.no.jotta.openapi.PingRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  no_jotta_openapi_ping_pb.PingResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.PingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.PingResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.PingResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.customer.v2.CustomerServiceClient.prototype.ping =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.customer.v2.CustomerService/Ping',
      request,
      metadata || {},
      methodDescriptor_CustomerService_Ping,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.PingRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.PingResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.customer.v2.CustomerServicePromiseClient.prototype.ping =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.customer.v2.CustomerService/Ping',
      request,
      metadata || {},
      methodDescriptor_CustomerService_Ping);
};


module.exports = proto.no.jotta.openapi.customer.v2;

